import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeSentry } from "./lib/sentry";
import { initializeAnalytics } from "./lib/analytics";

// Initialize error monitoring and analytics (analytics self-gates on consent + GPC)
initializeSentry();
initializeAnalytics();

createRoot(document.getElementById("root")!).render(<App />);
